import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';

export default function ContactSettings() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    api.get('/settings/contact')
      .then(r => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await api.put('/settings/contact', data);
      toast.success('İletişim ayarları güncellendi');
    } catch (err) {
      toast.error('Hata oluştu');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) return <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div data-testid="admin-contact-settings">
      <h1 className="font-heading text-2xl font-semibold mb-6">İletişim Ayarları</h1>
      <form onSubmit={handleSubmit} className="space-y-4 p-6 rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)]">
        <div>
          <label className="block text-sm font-medium mb-1.5">Adres</label>
          <textarea value={data?.address || ''} onChange={e => setData(d => ({ ...d, address: e.target.value }))} rows={2} className="w-full px-3 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--gold))] resize-none" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="E-posta" value={data?.email || ''} onChange={v => setData(d => ({ ...d, email: v }))} />
          <Field label="Telefon" value={data?.phone || ''} onChange={v => setData(d => ({ ...d, phone: v }))} />
          <Field label="GSM" value={data?.gsm || ''} onChange={v => setData(d => ({ ...d, gsm: v }))} />
          <Field label="WhatsApp Numarasi" value={data?.whatsapp || ''} onChange={v => setData(d => ({ ...d, whatsapp: v }))} placeholder="905XXXXXXXXX" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">Google Maps iframe</label>
          <textarea value={data?.map_iframe || ''} onChange={e => setData(d => ({ ...d, map_iframe: e.target.value }))} rows={3} placeholder='<iframe src="..." ...></iframe>' className="w-full px-3 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--gold))] resize-none font-mono" />
          <p className="text-xs text-muted-foreground mt-1">Google Maps'ten 'Paylas &gt; Haritayi Gom' ile alinan iframe kodunu yapistirin</p>
        </div>
        <button type="submit" disabled={isSubmitting} className="px-6 py-2.5 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] text-sm font-medium hover:bg-[hsl(var(--gold)/0.92)] disabled:opacity-50" data-testid="admin-save-button">
          {isSubmitting ? 'Kaydediliyor...' : 'Kaydet'}
        </button>
      </form>
    </div>
  );
}

const Field = ({ label, value, onChange, placeholder }) => (
  <div>
    <label className="block text-sm font-medium mb-1.5">{label}</label>
    <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className="w-full px-3 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--gold))]" />
  </div>
);
